import { Fullscreen16 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ButtonFullscreen.css';

export const ButtonFullscreen: React.FC<{ onClick?(): void }> = ({ onClick }) => {
  return (
    <button onClick={onClick} className={styles['container']}>
      <Fullscreen16 display="block" color="white_100" />
    </button>
  );
};
